<!-- PIN ENTRY SCREEN -->
<div class="pin-screen d-flex flex-column align-items-center justify-content-center min-vh-100">

  <div class="container text-center" style="max-width: 380px;">
    <h3 class="text-white fw-bold mb-5">{{ title }}</h3>

    <!-- PIN Dots/Number Display -->
    <!-- position-relative allows the eye icon to stay at the right without pushing the dots off-center -->
    <div class="position-relative d-flex justify-content-center align-items-center mb-5" style="min-height: 24px;">

      <!-- Dots Container: Centered Flex -->
      <div class="d-flex gap-3">
        <ng-container *ngFor="let i of [0,1,2,3,4,5]">
          <!-- Only render slot if the pin digit exists -->
          <ng-container *ngIf="pin.length > i">

            <!-- Hidden Mode: Dot -->
            <div *ngIf="!showPinVisible" class="pin-dot filled"></div>

            <!-- Visible Mode: Number -->
            <div *ngIf="showPinVisible" class="pin-number text-white fw-bold fs-4" [style.width.px]="15"
              [style.height.px]="24">
              {{ pin[i] }}
            </div>

          </ng-container>
        </ng-container>
      </div>

      <!-- Eye Icon: Absolutely positioned to the right -->
      <i class="bi position-absolute top-50 translate-middle-y text-white-50 cursor-pointer"
        [class.bi-eye-slash]="!showPinVisible" [class.bi-eye]="showPinVisible" (click)="onToggleVisibility()"
        style="right: 15px; font-size: 1.2rem;">
      </i>

    </div>

    <!-- Keypad Grid -->
    <div class="row g-2 mb-4 keypad-grid">
      <div class="col-4" *ngFor="let num of [1,2,3,4,5,6,7,8,9]">
        <button class="btn btn-keypad w-100" (click)="onDigit(num)">{{ num }}</button>
      </div>
      <div class="col-4"><button class="btn btn-keypad w-100 btn-action" (click)="onClear()">CLEAR</button></div>
      <div class="col-4"><button class="btn btn-keypad w-100" (click)="onDigit(0)">0</button></div>
      <div class="col-4">
        <button class="btn btn-keypad w-100 btn-action btn-submit-action" [disabled]="pin.length < 4 || isLoading"
          (click)="onSubmit()">
          <i class="bi bi-check-lg"></i>
        </button>
      </div>
    </div>

    <div *ngIf="errorMessage" class="alert alert-danger mt-3 py-2 small border-0 bg-danger bg-opacity-75 text-white">
      {{ errorMessage }}
    </div>
  </div>
</div>

